import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["rounded p-4 mb-4", {
      'text-red-600 bg-red-100 relative border-red-300': _ctx.type == 'error',
      'text-green-600 bg-green-100 relative border-green-300':
        _ctx.type == 'success',
      'text-yellow-600 bg-yellow-100 relative border-yellow-300':
        _ctx.type == 'warning',
      'text-blue-600 bg-blue-100 relative border-blue-300': _ctx.type == 'info'
    }])
  }, [
    (_ctx.showDismiss)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: "close",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handlelOnClose && _ctx.handlelOnClose(...args)))
        }))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "default", {}, undefined, true)
  ], 2))
}